import { devToolsApiRef } from '../api/DevToolsApi.esm.js';
import '@backstage/errors';
import { useApi } from '@backstage/core-plugin-api';
import useAsync from 'react-use/esm/useAsync';

function useConfig() {
  const api = useApi(devToolsApiRef);
  const { value, loading, error } = useAsync(() => {
    return api.getConfig();
  }, [api]);
  return {
    configInfo: value,
    loading,
    error
  };
}

export { useConfig };
//# sourceMappingURL=useConfig.esm.js.map
